import { AuctionLot, LotCardItemProps } from '@nx/global-types'

export function mapLotToLotCardItem(lot: AuctionLot): LotCardItemProps {
  return {
    image: lot.image || null,
    lotItemId: lot.lotItemId,
    lotIdNumber: lot.lotNo.number,
    lotIdLetter: lot.lotNo.letter,
    lotId: lot.lotId,
    lotUniqueId: lot.lotUniqueId,
    biddingEngine: lot.biddingEngine,
    symbols: lot.symbols || [],
    title: lot.title,
    styledDescription: lot.styledDescription,
    heading: lot.heading,
    status: lot.status,
    auctionStatus: lot.auctionStatus,
    auctionAMId: lot.auctionAMId,
    biddingStatus: lot.auctionBiddingStatus,
    isToBeSold: lot.flags.isToBeSold,
    isPreview: lot.flags.isPreview,
    isResultPublished: lot.flags.isResultPublished,
    isExhibition: lot.flags.isExhibition,
    isReferToDepartment: lot.flags.isReferToDepartment,
    isWithoutReserve: lot.flags.isWithoutReserve,
    isAmended: lot.flags.isAmended,
    currencySymbol: lot.price.currencySymbol,
    currencyISO: lot.currency?.iso_code,
    hammerPrice: lot.price.hammerPrice,
    hammerPremium: lot.price.hammerPremium,
    estimateLow: lot.price.estimateLow,
    estimateHigh: lot.price.estimateHigh,
    GBPLowEstimate: lot.price.GBPLowEstimate,
    GBPHighEstimate: lot.price.GBPHighEstimate,
    auctionType: lot.auctionType,
    lotAMId: lot.lotAMId,
    auctionId: lot.auctionId,
    brand: lot.brand,
    url: lot.url ?? '',
    hammerTime: {
      datetime: lot.hammerTime.datetime,
      timezone: lot.hammerTime.timezone,
    },
    biddableFrom: lot.biddableFrom
      ? {
          datetime: lot.biddableFrom.datetime,
          timezone: lot.biddableFrom.timezone,
        }
      : null,
  }
}
